import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import axios from 'axios';

const mockBase = [{title: 'Production', scansDay: '15 May', countApp: 228, countWeb: 23}, {title: 'Production', scansDay: '16 May', countApp: 435, countWeb: 77}, {title: 'Production', scansDay: '17 May', countApp: 667, countWeb: 45}, {title: 'Production', scansDay: '18 May', countApp: 239, countWeb: 72}, {title: 'Production', scansDay: '19 May', countApp: 863, countWeb: 98}]
const mockScans = {
  product: mockBase,
  company: mockBase.map((el: any) => {
    return {
      title: 'Company',
      scansDay: el.scansDay,
      countApp: el.countApp + 50,
      countWeb: el.countWeb + 25
    }
  }),
  standmans: mockBase.map((el: any) => {
    return {
      title: 'Booth staff',
      scansDay: el.scansDay,
      countApp: el.countApp -40,
      countWeb: el.countWeb + 30
    }
  }),
  visitors: mockBase.map((el: any) => {
    return {
      title: 'Visitor',
      scansDay: el.scansDay,
      countApp: el.countApp + 130,
      countWeb: el.countWeb - 15
    }
  })
}
const mock = [[1637629247,0],[1637643647,0],[1637647247,23],[1637650847,38],[1637654447,64],[1637658047,77],[1637661647,80],[1637665247,46],[1637668847,45],[1637672447,53],[1637676047,36],[1637679647,7],[1637683247,1],[1637686847,0],[1637694047,0],[1637697647,1],[1637701247,0],[1637730047,0],[1637733647,7],[1637737247,72],[1637740847,86],[1637744447,112],[1637748047,82],[1637751647,64],[1637755247,61],[1637758847,44],[1637762447,42],[1637766047,8],[1637769647,0],[1637816447,0],[1637820047,1],[1637823647,26],[1637827247,42],[1637830847,51],[1637834447,34],[1637838047,33],[1637841647,23],[1637845247,11],[1637848847,16],[1637852447,3],[1637856047,0],[1637859647,1],[1637863247,0],[1637906447,0],[1637910047,1],[1637913647,9],[1637917247,8],[1637920847,4],[1637924447,3],[1637928047,11],[1637931647,16],[1637935247,0],[1637960387,0]]

export interface State {
  loading: {
    total: boolean,
    rates: boolean,
    authInApp: boolean,
    visitorsDailyScans: boolean,
    visitorsAllScans: boolean,
    standmansDailyScans: boolean,
    standmansAllScans: boolean,
    companies: boolean,
    pending: boolean,
    custom: boolean,
    businessProgram: boolean,

    surveys: boolean,
    events: boolean,
    scans: boolean,
    scansByDays: boolean,
    banners: boolean,
    customContacts: boolean,
  },
  error: {
    total: boolean,
    rates: boolean,
    authInApp: boolean,
    visitorsDailyScans: boolean,
    visitorsAllScans: boolean,
    standmansDailyScans: boolean,
    standmansAllScans: boolean,
    companies: boolean,
    pending: boolean,
    custom: boolean,
    businessProgram: boolean,

    surveys: boolean,
    events: boolean,
    scans: boolean,
    scansByDays: boolean,
    banners: boolean,
    customContacts: boolean,
  },
  total: {},
  rates: {
    exhibitorsTotal: null | number,
    freeCount: null | number,
    businessCount: null | number,
    proCount: null | number,
    noRatesCount: null | number
  },
  authInApp: {},
  visitorsDailyScans: {},
  visitorsAllScans: {},
  standmansDailyScans: {},
  standmansAllScans: {},
  companies: {
    activeCompany: any[],
    popularCompany: any[]
  },
  pending: any[],
  custom: any[],
  businessProgram: any[],
  allCompanies: {
    activeCompany: any[],
    popularCompany: any[]
  },

  surveys: {},
  events: any[],
  scans: {
    productScans: {
      title: string,
      timestampScansCountApp: any[]
    },
    companyScans: {
      title: string,
      timestampScansCountApp: any[]
    },
    standmansScans: {
      title: string,
      timestampScansCountApp: any[]
    },
    visitorsScans: {
      title: string,
      timestampScansCountApp: any[]
    },
  },
  scansByDays: any,
  banners: any[],
  customContacts: any[],
  showCode: string
}

const defaultState: State = {
  loading: {
    total: false,
    rates: false,
    authInApp: false,
    visitorsDailyScans: false,
    visitorsAllScans: false,
    standmansDailyScans: false,
    standmansAllScans: false,
    companies: false,
    pending: false,
    custom: false,
    businessProgram: false,

    surveys: false,
    events: false,
    scans: false,
    scansByDays: false,
    banners: false,
    customContacts: false,
  },
  error: {
    total: false,
    rates: false,
    authInApp: false,
    visitorsDailyScans: false,
    visitorsAllScans: false,
    standmansDailyScans: false,
    standmansAllScans: false,
    companies: false,
    pending: false,
    custom: false,
    businessProgram: false,


    surveys: false,
    events: false,
    scans: false,
    scansByDays: false,
    banners: false,
    customContacts: false,
  },
  total: {
    standmansCount: null,
    productCount: null,
    createSurveysCount: null,
    visitorsCount: null,
    standsCount: null
  },
  rates: {
    exhibitorsTotal: null,
    freeCount: null,
    businessCount: null,
    proCount: null,
    noRatesCount: null
  },
  authInApp: {},
  visitorsDailyScans: {},
  visitorsAllScans: {},
  standmansDailyScans: {},
  standmansAllScans: {},
  companies: {
    activeCompany: [],
    popularCompany: []
  },
  pending: [],
  custom: [],
  businessProgram: [],
  allCompanies: {
    activeCompany: [],
    popularCompany: []
  },

  surveys: {
    timestampsCompletedSurveysCount: []
  },
  events: [],
  scans: {
    productScans: {
      title: '',
      timestampScansCountApp: []
    },
    companyScans: {
      title: '',
      timestampScansCountApp: []
    },
    standmansScans: {
      title: '',
      timestampScansCountApp: []
    },
    visitorsScans: {
      title: '',
      timestampScansCountApp: []
    },
  },
  scansByDays: {},
  banners: [],
  customContacts: [],
  showCode: ''
}

const getters = {
  total: (state: State) => state.total,
  rates: (state: State) => state.rates,
  authInApp: (state: State) => state.authInApp,
  visitorsDailyScans: (state: State) => state.visitorsDailyScans,
  visitorsAllScans: (state: State) => state.visitorsAllScans,
  standmansDailyScans: (state: State) => state.standmansDailyScans,
  standmansAllScans: (state: State) => state.standmansAllScans,
  companies: (state: State) => state.companies,
  pending: (state: State) => state.pending,
  custom: (state: State) => state.custom,
  businessProgram: (state: State) => state.businessProgram,
  allCompanies: (state: State) => state.allCompanies,
  
  
  surveys: (state: State) => state.surveys,
  events: (state: State) => state.events,
  scans: (state: State) => state.scans,
  scansByDays: (state: State) => state.scansByDays,
  banners: (state: State) => state.banners,
  customContacts: (state: State) => state.customContacts,
  loading: (state: State) => state.loading,
  error: (state: State) => state.error,
  showCode: (state: State) => state.showCode,
}

const mutations: MutationTree<State> = {
  setLoading(state: State, payload) {
    state.loading = {
      ...state.loading,
      ...payload
    }
  },
  setError(state:State, payload: any) {
    state.error = {
      ...state.error,
      ...payload }
  }
}

const actions: ActionTree<State, RootState> = {
  async total({commit, state}) {
    commit('setLoading', {total: true})
    commit('setError', {total: false})
    state.total =  {
      standmansCount: null,
      productCount: null,
      createSurveysCount: null,
      visitorsCount: null,
      standsCount: null
    }
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/summary-count`)
      state.total = data.data
    } catch (e) {
      commit('setError', {total: true})
    } finally {
      commit('setLoading', {total: false})
    }
  },
  async rates({commit, state}) {
    commit('setLoading', {rates: true})
    commit('setError', {rates: false})
    state.rates = {
      exhibitorsTotal: null,
      freeCount: null,
      businessCount: null,
      proCount: null,
      noRatesCount: null
    }
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/rates`)
      state.rates = data.data
    } catch (e) {
      commit('setError', {rates: true})
    } finally {
      commit('setLoading', {rates: false})
    }
  },
  async authInApp({commit, state}) {
    commit('setLoading', {authInApp: true})
    commit('setError', {authInApp: false})
    state.authInApp = {}
    try {
        const {data} = await axios.get(`v4/statistic/show/${state.showCode}/installs`)

        if (data.status === 'err') {state.authInApp = []} else
        { state.authInApp = data.data}

    } catch (e) {
      commit('setError', {authInApp: true})
    } finally {
      commit('setLoading', {authInApp: false})
    }
  },
  async visitorsDailyScans({commit, state}) {
    commit('setLoading', {visitorsDailyScans: true})
    commit('setError', {visitorsDailyScans: false})
    state.visitorsDailyScans = {}
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/daily-scans/visitors`)
      let scans:any = {
        sumSurveys: [],
        visitorsScans: []
      }
      for(let key in data.data) {
        if( data.data[key].length > 0) {
          for(let keyScan in data.data[key]) {
            data.data[key][keyScan]['tmst'] *= 1000
            scans[key].push([data.data[key][keyScan]['tmst'], data.data[key][keyScan]['count']])
          }
        }
      }
      for(let key in scans) {
        scans[key] = scans[key].sort((a:any, b:any) => a[0] - b[0])
      }
      state.visitorsDailyScans = scans
    } catch (e) {
      commit('setError', {visitorsDailyScans: true})
    } finally {
      commit('setLoading', {visitorsDailyScans: false})
    }
  },
  async visitorsAllScans({commit, state}) {
    commit('setLoading', {visitorsAllScans: true})
    commit('setError', {visitorsAllScans: false})
    state.visitorsAllScans = {}
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/total-scans/visitors`)
      let scans = data.data
      let currentScans:any = {
        visitors: [],
      }
      scans.forEach((scan:any) => {
        currentScans.visitors.push({...scan.visitors, date: scan.timestamp})
      });
      currentScans.visitors = currentScans.visitors.sort((a:any, b:any) => a.date - b.date)
      state.visitorsAllScans = currentScans
    } catch (e) {
      commit('setError', {visitorsAllScans: true})
    } finally {
      commit('setLoading', {visitorsAllScans: false})
    }
  },
  async standmansDailyScans({commit, state}) {
    commit('setLoading', {standmansDailyScans: true})
    commit('setError', {standmansDailyScans: false})
    state.standmansDailyScans = {}
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/daily-scans/standmans`)
      let scans:any = {}
      for(let key in data.data) {
        scans[key] = []
        for(let keyScan in data.data[key]) {
          scans[key].push([data.data[key][keyScan]['tmst'] * 1000, data.data[key][keyScan]['count']])
        }
      }
      state.standmansDailyScans = scans
    } catch (e) {
      commit('setError', {standmansDailyScans: true})
    } finally {
      commit('setLoading', {standmansDailyScans: false})
    }
  },
  async standmansAllScans({commit, state}) {
    commit('setLoading', {standmansAllScans: true})
    commit('setError', {standmansAllScans: false})
    state.standmansAllScans = {}
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/total-scans/standmans`)
      let scans = data.data
      let currentScans:any = {
        company: [],
        product: [],
        standmans: [],
      }
      scans.forEach((scan:any) => {
        currentScans.company.push({...scan.company, date: scan.timestamp})
        currentScans.product.push({...scan.product, date: scan.timestamp})
        currentScans.standmans.push({...scan.standmans, date: scan.timestamp})
      });
      state.standmansAllScans = currentScans
    } catch (e) {
      commit('setError', {standmansAllScans: true})
    } finally {
      commit('setLoading', {standmansAllScans: false})
    }
  },
  async companies({commit, state}) {
    commit('setLoading', {companies: true})
    commit('setError', {companies: false})
    state.companies = {
      activeCompany: [],
      popularCompany: []
    }
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/popular-companies?returnAll=0`)
      state.companies = data.data
    } catch (e) {
      commit('setError', {companies: true})
    } finally {
      commit('setLoading', {companies: false})
    }
  },
  async allCompanies({commit, state}) {
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/popular-companies?returnAll=1`)
      state.allCompanies = data.data
    } catch (e) {
    } finally {
    }
  },
  async pending({commit, state}) {
    commit('setLoading', {pending: true})
    commit('setError', {pending: false})
    state.pending = []
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/pending`)
      data.data.forEach((item:any) => {
        state.pending.push([item.tmst, item.count])
      })
      state.pending = state.pending.sort((a:any, b:any) => a[0] - b[0])
    } catch (e) {
      commit('setError', {pending: true})
    } finally {
      commit('setLoading', {pending: false})
    }
  },
  async custom({commit, state}) {
    commit('setLoading', {custom: true})
    commit('setError', {custom: false})
    state.custom = []
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/custom-contact`)
      data.data.forEach((item:any) => {
        state.custom.push([item.tmst, item.count])
      })
      state.custom = state.custom.sort((a:any, b:any) => a[0] - b[0])
    } catch (e) {
      commit('setError', {custom: true})
    } finally {
      commit('setLoading', {custom: false})
    }
  },
  async businessProgram({commit, state}) {
    commit('setLoading', {businessProgram: true})
    commit('setError', {businessProgram: false})
    state.businessProgram = []
    try {
      const {data} = await axios.get(`v4/show/${state.showCode}/business-program`)
      data.data.forEach((item:any) => {
        state.businessProgram.push([item.tmst, item.count])
      })
      state.businessProgram = data.data
    } catch (e) {
      commit('setError', {businessProgram: true})
    } finally {
      commit('setLoading', {businessProgram: false})
    }
  },
  
  async surveys({commit, state}) {
    commit('setLoading', {surveys: true})
    commit('setError', {surveys: false})
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/completed-surveys`)
      state.surveys = data.data
    } catch (e) {
      commit('setError', {surveys: true})
    } finally {
      commit('setLoading', {surveys: false})
    }
  },
  async scans({commit, state}) {
    commit('setLoading', {scans: true})
    commit('setError', {scans: false})
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/daily-scans`)
      let scans = data.data
      for(let key in scans) {
        scans[key].forEach((scan:any) => {
          scan[0] = scan[0]*1000
        })
      }
      state.scans = scans
      } catch (e) {
      commit('setError', {scans: true})
    } finally {
      commit('setLoading', {scans: false})
    }
  },
  async customContacts({commit, state}) {
    commit('setLoading', {customContacts: true})
    commit('setError', {customContacts: false})
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/custom-contact`)
      state.customContacts = data.data.custom
    } catch (e) {
      commit('setError', {customContacts: true})
    } finally {
      commit('setLoading', {customContacts: false})
    }
  },
  async banners({commit, state}) {
    commit('setLoading', {banners: true})
    commit('setError', {banners: false})
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/banners`)
      state.banners = data.data
    } catch (e) {
      commit('setError', {banners: true})
    } finally {
      commit('setLoading', {banners: false})
    }
  },
  async events({commit, state}) {
    commit('setLoading', {events: true})
    commit('setError', {events: false})
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/events`)
      state.events = data.data.events
    } catch (e) {
      commit('setError', {events: true})
    } finally {
      commit('setLoading', {events: false})
    }
  },
  async scansByDays({commit, state}) {
    commit('setLoading', {scansByDays: true})
    commit('setError', {scansByDays: false})
    try {
      const {data} = await axios.get(`v4/statistic/show/${state.showCode}/total-scans`)
      let scans = data.data
      let currentScans:any = {
        company: [],
        product: [],
        standmans: [],
        visitors: [],
      }
      scans.forEach((scan:any) => {
      currentScans.company.push({...scan.company, date: scan.timestamp})
        currentScans.product.push({...scan.product, date: scan.timestamp})
        currentScans.standmans.push({...scan.standmans, date: scan.timestamp})
        currentScans.visitors.push({...scan.visitors, date: scan.timestamp})
      });
      state.scansByDays = currentScans
    } catch (e) {
      commit('setError', {scansByDays: true})
    } finally {
      commit('setLoading', {scansByDays: false})
    }
  },
  loadAll({dispatch, state}, payload:any) {
    state.showCode = payload
   if(payload !== undefined){
     dispatch('total')
     dispatch('rates')
     dispatch('authInApp')
     dispatch('visitorsDailyScans')
     dispatch('visitorsAllScans')
     dispatch('standmansDailyScans')
     dispatch('standmansAllScans')
     dispatch('companies')
     dispatch('pending')
     dispatch('custom')
     dispatch('businessProgram')
     /*dispatch('surveys')
     dispatch('scans')
     dispatch('customContacts')
     dispatch('banners')
     dispatch('events')
     dispatch('scansByDays')*/
   }

  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
